import { useParams } from 'react-router-dom';

import { PortalConhecimento } from './PortalConhecimento'

export const PortalConhecimentoContainer = () => {

  const { id } = useParams<{ id: string }>();

   const url =
    id === 'reforma-tributaria'
      ? 'https://portaldoconhecimento.microuniverso.com.br/index.php/Categoria:Reforma_Tributária'
      : 'https://portaldoconhecimento.microuniverso.com.br/index.php/P%C3%A1gina_principal';

  return (
    <>
      <PortalConhecimento url={url} />
    </>
  )
}
